// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V-Bj","top":"styles_top__1a-2l","left":"styles_left__dcFtb","description":"styles_description__3KvNl"};